<p class="font-bold line-height-2" i18n>
  Industry standard specifies that mobile device reads emergency call codes stored in an eSIM upon power-on. Then, it shall store the codes
  as part of its initialization procedure. The emergency call codes will be used in setting up an emergency call.
</p>
<p class="font-bold line-height-2" i18n>Please enter the code(s) and associated emergency service category.</p>
<div class="ml-6 mr-6">
  <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />
  <div style="width: 750px">
    <p-table
      showGridlines="true"
      stripedRows="true"
      [value]="profileValues.emergencyCallCodes"
      [(selection)]="selectedCallCodes"
      dataKey="id"
    >
      <ng-template pTemplate="caption">
        <div class="flex align-items-center gap-2">
          <p-button
            i18n-label
            label="Add Code"
            icon="pi pi-plus-circle"
            size="small"
            [outlined]="true"
            (onClick)="addEmergencyCallCode()"
          ></p-button>
          <p-button
            i18n-label
            label="Delete"
            icon="pi pi-trash"
            size="small"
            severity="danger"
            [outlined]="true"
            (onClick)="deleteEmergencyCallCodes()"
            [disabled]="!selectedCallCodes || !selectedCallCodes.length"
          ></p-button>
        </div>
      </ng-template>
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 3rem" />
          <col style="width: 7rem" />
          <col />
          <col />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th i18n>Record #</th>
          <th>
            <div i18n>Emergency Call Code</div>
            <div class="font-medium" i18n>(e.g., 911, 112, 999)</div>
          </th>
          <th>
            <div i18n>Emergency Service Category</div>
            <div class="font-medium" i18n>(use drop-down)</div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-callCode let-rowIndex="rowIndex">
        <tr>
          <td style="text-align: center">
            <p-tableCheckbox [value]="callCode"></p-tableCheckbox>
          </td>
          <td style="text-align: center">{{ rowIndex + 1 }}</td>
          <td>
            <input
              pInputText
              rsNumbersOnlyInput
              class="maximize-inputs console-text"
              [maxlength]="6"
              [(ngModel)]="callCode.callCode"
              (input)="handleFormEvents()"
            />
          </td>
          <td>
            <p-select
              styleClass="maximize-inputs"
              [options]="emergencyServiceCategoryOptions"
              [(ngModel)]="callCode.serviceCategory"
              dataKey="value"
              optionLabel="label"
              i18n-placeholder
              placeholder="Please Select:"
              appendTo="body"
              (onChange)="handleFormEvents()"
            ></p-select>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" i18n>No emergency call codes defined.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
